import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["captchaForm", "submit"]

  connect() {
  }

  loadCaptcha() {
    if (!window.captchaLoaded) {
      window.captchaLoaded = true
      var src = "https://hcaptcha.com/1/api.js"

      loadScript(src, this._renderCaptcha.bind(this));
    } else {
      this._renderCaptcha();
    }
  }

  _renderCaptcha() {
    const siteKey = this.captchaFormTarget.dataset.siteKey;

    window.hcaptcha.render(
      this.captchaFormTarget.id,
      { "sitekey": siteKey, "callback": this._enableFormSubmitButton.bind(this) }
    );
  }

  _setResponseToken(responseToken) {
    const input = document.createElement("input");

    input.setAttribute("type", "hidden");
    input.setAttribute("name", "response_token");
    input.setAttribute("value", responseToken);

    this.captchaFormTarget.appendChild(input);
  }

  _enableFormSubmitButton(responseToken) {
    this._setResponseToken(responseToken);
    this.submitTarget.disabled = false;
  }
}
